import React from 'react';
import { Typography } from 'antd';
import LegalPage from 'common/components/LegalPage';

const { Title, Paragraph } = Typography;

const TermsOfUsePage = () => (
  <LegalPage effectiveDate="June 1, 2026" title="Terms of Use">
    <Title level={3}>Acceptance of these Terms</Title>
    <Paragraph>
      These Terms of Use (“Terms”) govern the relationship between you (“You”, or “Your”) and Acts 2 Network
      (“We”, “us”, or “our”) concerning the Acts 2 Network membership management application located at
      tribe.gracepointonline.org, and all of its affiliated sites and subdomains (the “Site”), together with all
      content, features, and materials made available through it (collectively, the “Content”). Please read these
      Terms carefully before you start using the Site. By using or accessing the Site, You accept these Terms and
      represent and warrant that You are 18 years of age or older. If You are agreeing to these Terms on behalf of a
      company or other legal entity, You warrant that You have the authority to bind such entity to these Terms, in
      which case “You” or “Your” shall also include such entity.
    </Paragraph>

    <Title level={3}>Changes to the Terms</Title>
    <Paragraph>
      We may revise and update these Terms from time to time at our sole discretion. Any changes are effective when
      we post them. Your continued use of the Site following the posting of revised Terms means that you accept and
      agree to the changes. While we hope to always offer the Site and all of its features and content, we reserve
      the right to change, modify, or cease offering the Site or any part, portion, content or functionality
      available through the Site without notice, temporarily or permanently. We will not be liable to you or any
      third party if for any reason all or any part of the Site is unavailable at any time.
    </Paragraph>

    <Title level={3}>Information About You</Title>
    <Paragraph>
      We do not share your personal data or your device information with any third-party advertisers or ad networks
      for their advertising purposes. We may use the personal data and device information available to us to observe
      social, behavioral, economic, and geographic trends as they pertain to ministry. We may use the data you
      provide (which can include your communications) to investigate, respond to and resolve complaints, legal,
      security and technical issues concerning the Site or Us. We use your data and communications if we think it is
      necessary for security purposes or to investigate possible fraud or violations of law or these Terms and/or
      attempts to harm others (See the Section “Disclosure of Your Identity” below).
    </Paragraph>

    <Title level={3}>User Conduct</Title>
    <Paragraph>
      You understand that all materials (including but not limited to text, messages, posts, or any other materials)
      transmitted by You or any individual or entity using and/or accessing the Site or Content (each, a “User”) via
      the Site or concerning the Site (or any Content therein), whether publicly posted or privately transmitted
      elsewhere, is Your sole responsibility or the responsibility of the User who originates it. This means that You
      are entirely responsible for all materials that you upload, post, email, transmit or otherwise make available
      via the Site or concerning the Site (or any Content therein). You agree not to use the Site to:
    </Paragraph>
    <Paragraph>
      <ul>
        <li>
          upload, post, email, transmit or otherwise make available any materials that is unlawful, harmful,
          threatening, abusive, harassing, tortious, defamatory, vulgar, obscene, libelous, invasive of another’s
          privacy, hateful, discriminatory, or racially, ethnically or otherwise objectionable;
        </li>
        <li>harm minors in any way;</li>
        <li>
          impersonate any person or entity, or falsely state or otherwise misrepresent your affiliation with a person
          or entity;
        </li>
        <li>
          upload, post, email, transmit or otherwise make available any materials or Content that you do not have a
          right to make available under any law or under contractual or fiduciary relationships (such as inside
          information, proprietary and confidential information learned or disclosed as part of employment
          relationships or under nondisclosure agreements);
        </li>
        <li>
          upload, post, email, transmit or otherwise make available any materials that infringes any patent,
          trademark, trade secret, copyright or other proprietary rights of any party;
        </li>
        <li>
          upload, post, email, transmit or otherwise make available any unsolicited or unauthorized advertising,
          promotional materials, “junk mail,” “spam,” “chain letters,” “pyramid schemes,” or any other form of
          solicitation;
        </li>
        <li>
          upload, post, email, transmit or otherwise make available any material that contains software viruses or
          any other computer code, files or programs designed to interrupt, destroy or limit the functionality of any
          computer software or hardware or telecommunications equipment;
        </li>
        <li>to harm Acts 2 Network or users of the Site expose them to liability;</li>
        <li>
          to introduce any viruses, Trojan horses, worms, logic bombs, or other material which is malicious or
          technologically harmful;
        </li>
        <li>intentionally or unintentionally violate any applicable local, state, federal law or regulation;</li>
        <li>
          collect or store personal data about other users or in connection with the prohibited conduct and
          activities set forth above.
        </li>
      </ul>
    </Paragraph>

    <Title level={3}>Disclosure of Your Identity</Title>
    <Paragraph>
      We may disclose any personal information we have about you (including your identity) if we determine that a
      disclosure is necessary in connection with any investigation or complaint regarding your use of the Site, or to
      identify, contact or bring legal action against someone who may be causing injury to or interference with
      (either intentionally or unintentionally) our rights or property, or the rights or property of visitors to or
      users of the Site. We reserve the right at all times to disclose any information that we deem necessary to
      comply with any applicable law, regulation, legal process or governmental request.
    </Paragraph>
    <Paragraph>
      You acknowledge, consent, and agree that we may access, preserve, and disclose your personal account
      information and any materials you transmitted if required to do so by law or in a good faith belief that
      access, preservation, or disclosure is reasonably necessary to:
    </Paragraph>
    <Paragraph>
      <ul>
        <li>comply with legal process;</li>
        <li>enforce these Terms;</li>
        <li>
          respond to claims that any materials You transmitted or submitted violates the rights of third parties;
          and/or
        </li>
        <li>
          protect our rights, property, or personal safety, other visitors to or users of the Site, and the public.
        </li>
      </ul>
    </Paragraph>
    <Paragraph>
      You understand that the technical processing and transmission of the Site, including any materials transmitted
      by You, may involve transmissions over various networks and changes to conform and adapt to technical
      requirements of connecting networks or devices.
    </Paragraph>

    <Title level={3}>Termination</Title>
    <Paragraph>
      You agree that we may, for any reason or no reason and without prior notice, at our sole discretion,
      immediately terminate Your access to the Site at any time and for any reason, and shall not be liable to You or
      any third party for any termination of Your access to the Site for any reason. You agree that We will not be
      liable to You or to any third party for termination of Your access to the Site as a result of any violation of
      these Terms.
    </Paragraph>

    <Title level={3}>Disclaimer of Warranties</Title>
    <Paragraph>
      THE SITE AND THE CONTENT ARE PROVIDED TO YOU FREE OF CHARGE AND ARE THEREFORE PROVIDED ON AN “AS IS” BASIS
      WITHOUT ANY CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, AND WARRANTIES OR
      CONDITIONS OF TITLE, NON-INFRINGEMENT, WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. WE DO
      NOT GUARANTEE THAT THE SITE WILL ALWAYS BE SAFE, SECURE OR ERROR-FREE OR THAT THE SITE WILL ALWAYS FUNCTION
      WITHOUT DISRUPTIONS, DELAYS OR IMPERFECTIONS. WE ARE NOT RESPONSIBLE FOR THE ACTIONS, CONTENT, INFORMATION, OR
      DATA OF THIRD PARTIES, AND YOU RELEASE US, OUR DIRECTORS, OFFICERS, EMPLOYEES, MEMBERS, USERS, AND AGENTS FROM
      ANY CLAIMS AND DAMAGES, KNOWN AND UNKNOWN, ARISING OUT OF OR IN ANY WAY CONNECTED WITH ANY CLAIM YOU HAVE
      AGAINST ANY THIRD PARTIES THAT IS RELATED TO THE SITE, CONTENT YOU ACQUIRE FROM THE SITE OR USE OF THE SITE OR
      CONTENT.
    </Paragraph>

    <Title level={3}>Indemnity</Title>
    <Paragraph>
      You agree to defend, indemnify and hold harmless Acts 2 Network, our officers, directors, shareholders,
      predecessors, successors in interest, employees, members, agents, subsidiaries, and affiliates, harmless from
      any demands, loss, liability, claims or expenses (including attorneys’ fees), made against us due to or arising
      out of or in connection with Your use of the Site or Content, or Your breach of these Terms.
    </Paragraph>

    <Title level={3}>Limitation of Liability</Title>
    <Paragraph>
      You are solely responsible for determining the appropriateness of using or redistributing the materials
      transmitted by You and assume any risks associated with use under these Terms.
    </Paragraph>
    <Paragraph>
      IN NO EVENT AND UNDER NO LEGAL THEORY, WHETHER IN TORT (INCLUDING NEGLIGENCE), CONTRACT, OR OTHERWISE, UNLESS
      REQUIRED BY APPLICABLE LAW OR AGREED TO IN WRITING, WILL ACTS 2 NETWORK BE LIABLE TO YOU FOR DAMAGES, INCLUDING
      ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF ANY CHARACTER ARISING AS A RESULT OF
      THESE TERMS OR OUT OF THE USE OR INABILITY TO USE THE CONTENT (INCLUDING BUT NOT LIMITED TO DAMAGES FOR LOSS OF
      GOODWILL, WORK STOPPAGE, COMPUTER FAILURE OR MALFUNCTION, OR ANY AND ALL OTHER COMMERCIAL DAMAGES OR LOSSES),
      EVEN IF YOU HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
    </Paragraph>
    <Paragraph>
      YOU EXPRESSLY UNDERSTAND AND AGREE THAT ANY CONTENT DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THE SITE
      IS ACCESSED AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER
      SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY DOWNLOADED MATERIAL.
    </Paragraph>
    <Paragraph>
      The Site may provide links to other websites or resources. You acknowledge and agree that We have no control
      over, are not responsible for the availability of, and do not endorse and are not responsible or liable for,
      any content, advertising, products or other materials on or available from other sites or resources. You
      acknowledge and agree that we are not responsible in any way for any damage or loss caused by or in connection
      with use of or reliance on any site or resource.
    </Paragraph>

    <Title level={3}>Notice and Procedure for Making Claims of Intellectual Property Infringement</Title>
    <Paragraph>
      We respect the intellectual property of others. If You believe that Your work has been copied in a way that
      constitutes copyright infringement, or Your intellectual property rights have been otherwise violated, please
      send the following information to privacy@acts2.network.
    </Paragraph>
    <Paragraph>
      <ul>
        <li>
          an electronic or physical signature of the person authorized to act on behalf of the owner of the copyright
          or other intellectual property interest in question;
        </li>
        <li>
          a written description of the copyrighted work or other intellectual property that you claim has been
          infringed;
        </li>
        <li>a written description of where the material that you claim is infringing is located on the Site;</li>
        <li>your address, telephone number, and email address (all that apply);</li>
        <li>
          a written statement by You that You have a good faith belief that the disputed use is not authorized by the
          copyright owner, its agent, or the law; and
        </li>
        <li>
          a written statement by You, made under penalty of perjury, that the above information in Your notice is
          accurate and that you are the copyright or intellectual property owner, or that You are authorized to act on
          the behalf of the copyright or intellectual property owner.
        </li>
      </ul>
    </Paragraph>

    <Title level={3}>Violation of These Terms of Use</Title>
    <Paragraph>
      If We take any legal action against You as a result of Your violation of these Terms, we will be entitled to
      recover from You, and You agree to pay, all reasonable attorneys’ fees and costs of such action, in addition to
      any other relief granted to Us. You agree that We will not be liable to You or to any third party for
      termination of your access to the Site as a result of any violation of these Terms. You also agree that any
      violation by You of these Terms will constitute an unlawful and unfair business practice, and will cause
      irreparable harm to Us, for which monetary damages would be inadequate, and you consent to Us obtaining any
      injunctive or equitable relief that We deem necessary or appropriate in these circumstances. These remedies are
      in addition to any other remedies We may have at law or in equity.
    </Paragraph>

    <Title level={3}>Governing Law &amp; Dispute Resolution</Title>
    <Paragraph>
      All matters, disputes or claims relating to the Site and these Terms (including non-contractual disputes or
      claims) (each, a “Claim”), shall be governed by and construed in accordance with the internal laws of the State
      of California without giving effect to any choice or conflict of law provision or rule. Any legal suit, action
      or proceeding arising out of, or related to, these Terms or the Site shall be instituted exclusively in the
      federal courts of the United States or the courts of the State of California in each case located in the City
      of Oakland, Alameda County. By agreeing to these Terms, you waive any and all objections to the exercise of
      jurisdiction over you by such courts and to venue in such courts.
    </Paragraph>

    <Title level={3}>No Third-Party Beneficiaries</Title>
    <Paragraph>
      You agree that, except as otherwise expressly provided within these Terms, there shall be no third-party
      beneficiaries to these Terms.
    </Paragraph>

    <Title level={3}>Waiver and Severability</Title>
    <Paragraph>
      Acts 2 Network may only waive its rights under these Terms in writing. If any provision of these Terms is held by
      a court or other tribunal of competent jurisdiction to be invalid, illegal or unenforceable for any reason,
      such provision shall be eliminated or limited to the minimum extent such that the remaining provisions of these
      Terms will continue in full force and effect.
    </Paragraph>

    <Title level={3}>Entire Agreement</Title>
    <Paragraph>
      These Terms constitute the sole and entire agreement between You and Acts 2 Network with respect to the Site and
      supersede all prior and contemporaneous understandings, agreements, representations and warranties, both
      written and oral, with respect to the Site.
    </Paragraph>
  </LegalPage>
);

export default TermsOfUsePage;
